module.exports = __webpack_public_path__ + "img/face_placeholder.6a20c676.png";